import styled from 'styled-components';
import React, { FC } from 'react';
import { useSettings } from '../../contexts/settingsContext';

interface Props {
  radius: string;
}

const Border = styled.div<Props>`
  border-radius: ${({ radius }) => `${radius}`};
  border: 1px solid #e0e0e0;
`;

const SurroundingBorder: FC = ({ children }): JSX.Element => {
  const { cornerRadius: radius } = useSettings();
  return <Border radius={radius}>{children}</Border>;
};

export default SurroundingBorder;
